import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import ModalLayout from './modalLayout';
import SessionDetails from '../../interpreterPage/sessionTable/sessionDetails';
import { InviteLink } from '../../';
import InfoText from '../sessionForm/infoText';

const SessionCreatedModal = ({ open, session, ...rest }) => {
  const { t } = useTranslation();

  return (
    <ModalLayout
      open={open}
      headerText={t('modal.newSession')}
      {...rest}
      rightButtonProps={{ color: 'white' }}
      rightButtonText={t('modal.close')}
      size="lg"
    >
      <SessionDetails
        session={session}
        durationSeconds={session.estimatedDurationSeconds}
        status={t('interpreter.statusNew')}
      />
      <InviteLink my={4} url={session.url} />
      <InfoText text={t('interpreter.modal.createdInfo')} />
    </ModalLayout>
  );
};

SessionCreatedModal.propTypes = {
  open: PropTypes.bool.isRequired,
  session: PropTypes.object.isRequired,
};

SessionCreatedModal.defaultProps = {
  open: false,
};

export default SessionCreatedModal;
